export default "Devlog #9 is here on the 2-year anniversary of the <a href=\"/left-turn-legend\">Left Turn Legend</a> Devlog Series!";